import React, { useState } from 'react';
import './index.css';
import { IoIosStar } from "react-icons/io";
import MyModelsTable from './table';
import NoData from '../NoData';

export default function MyModelsCard({ model }) {

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(curr => !curr);
  };

  // console.log(model)

  return (
    <>
      <div className="mmc-layout" onClick={handleOpen}>
        <div className="mmc-name">
          {model.name} v{model.version}
        </div>
        <div className="mmc-star">
          <div className="mmc-star-icon">
            <IoIosStar style={{fontSize: 15}} />
          </div>
          <div className="mmc-star-num">
            {model?.m2dModelStars?.length}
          </div>
        </div>
      </div>
      <div className={`mmc-info-layout${open ? "" : "-closed"}`}>
        <div className="mmc-info">
          {model.m2dResults.length > 0 ? (
            <MyModelsTable results={model.m2dResults} />
          ) : (
            <NoData info='No performance available' style={{
              height: '160px',
              marginTop: '0px',
              marginBottom: '10px'
            }} />
          )}
        </div>
      </div>
    </>
  )
}
